import React from 'react'

export default function Footer() {
  return (
    <div style={{textAlign: 'center', marginBottom:10 }}>
        All copy rights reserved: Quiz App
    </div>
  )
}
